import React from 'react'
import { useDispatch } from 'react-redux'
import ProPlans from './index'
import { showUpgradeModal } from '../../Manage/actions'
import CustomModal from 'components/CustomModal/CustomModal'

export const isMobileMode = () => {
  try {
    return window?.localStorage?.getItem('mobile-mode') === 'true'
  } catch (err) {
    return false
  }
}

const MobilePricingMessage = () => (
  <div className="d-flex flex-column align-items-center justify-content-center">
    <div className="p-2 text-center text-secondary fw-medium my-4">
      Unfortunately, you cannot upgrade from within this app.
    </div>
  </div>
)

export const PricingMobileModal = ({ show, onClose }) => {
  return (
    <CustomModal
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="upgrade-modal-backdrop"
      size="xl"
      onHide={() => {
        onClose()
      }}
      show={show}
      centered
      enforceFocus={false}
      mobileCloseButton={true}
    >
      <div className={`plans-modal text-center ps-5 pe-5 pe-md-0 ps-md-0`}>
        <h1 className="bold mt-2 font-24 color-purple">Upgrade for more</h1>
        <MobilePricingMessage />{' '}
      </div>
    </CustomModal>
  )
}

const PricingModalContent = ({ email, source, hideFreeCard, hideMaxCard, hideTable, className, onFreeClick }) => {
  const dispatch = useDispatch()

  if (isMobileMode()) {
    return <MobilePricingMessage />
  }

  return (
    <ProPlans
      className={className}
      email={email}
      onPaymentClickCallback={() => dispatch(showUpgradeModal(false))}
      onPaymentHideCallback={() => dispatch(showUpgradeModal(false))}
      source={source}
      showModal
      hideFreeCard={hideFreeCard}
      hideMaxCard={hideMaxCard}
      hideTable={hideTable}
    />
  )
}

export default PricingModalContent
